module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-08-24 at 14.52.53.05801ce0.png";